module.exports = window.SkeduloPlatform.React